import React from "react";

import Navbar from "../partials/Navbar";
import Footer from "../partials/Footer";

const Layout = (props) => {
  return (
    <div className="flex flex-col h-[calc(100vh)] text-sm 2xl:text-base max-w-screen-2xl mx-auto">
      <Navbar />
      {props.children}
      <Footer />
    </div>
  );
};

export default Layout;
